import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { colors } from "@/theme/colors";

type Props = {
  paidAmount: number;
  cancelFee: number;
  refundAmount: number;
  // 決済カードの下 4 桁 (返金方法の表示用)。
  cardLast4: string;
};

function AmountRow({ label, value }: { label: string; value: number }) {
  return (
    <ListItem sx={{ display: "flex", justifyContent: "space-between", px: 0, py: 0.75 }}>
      <Typography sx={{ color: colors.textMuted, fontSize: 14 }}>{label}</Typography>
      <Typography sx={{ color: colors.textBody, fontSize: 16, fontWeight: 600 }}>
        ¥{value.toLocaleString()}
      </Typography>
    </ListItem>
  );
}

/**
 * ご返金内容セクション。支払済金額・キャンセル料・返金予定金額をリスト表示し、
 * 返金方法 (カード返金) は背景色付きのブロックで別枠表示する。
 *
 * 金額は GetReservation が返す予定額 (§7.4) 由来 (JPTP_CANSEI-1269 / -1415)。
 */
export function RefundInfoSection({ paidAmount, cancelFee, refundAmount, cardLast4 }: Props) {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, color: colors.text, mb: 1 }}>
        {t("cancelReservation.refundTitle")}
      </Typography>
      <List disablePadding>
        <AmountRow label={t("cancelReservation.paidAmount")} value={paidAmount} />
        <AmountRow label={t("cancelReservation.cancelFee")} value={cancelFee} />
        <AmountRow label={t("cancelReservation.refundAmount")} value={refundAmount} />
      </List>

      <Box sx={{ bgcolor: colors.surfaceMuted, borderRadius: 2, p: 2, mt: 2 }}>
        <Typography sx={{ color: colors.textMuted, fontSize: 13, fontWeight: 600, mb: 0.5 }}>
          {t("cancelReservation.refundMethodTitle")}
        </Typography>
        <Typography sx={{ color: colors.textBody, fontSize: 15, mb: 1.5 }}>
          {t("cancelReservation.refundMethodValue", { last4: cardLast4 })}
        </Typography>
        <Typography sx={{ color: colors.textMuted, fontSize: 13, fontWeight: 600, mb: 0.5 }}>
          {t("cancelReservation.refundProcessTitle")}
        </Typography>
        <Typography sx={{ color: colors.textBody, fontSize: 15 }}>
          {t("cancelReservation.refundProcessValue")}
        </Typography>
      </Box>
    </Box>
  );
}
